import { render, staticRenderFns } from "./CustomerTypeForm.vue?vue&type=template&id=c3db0e80&"
import script from "./CustomerTypeForm.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports